import { useEffect, useState } from 'react';
import { LuInfo } from 'react-icons/lu';

import GeneralInfoModal from './general-info-modal/general-info-modal.component';

const ID = 'general-info-button';

interface GeneralInfoButtonProps {
    isOpenCallback?: (isOpen: boolean) => void;
}

const GeneralInfoButton = ({ isOpenCallback }: GeneralInfoButtonProps) => {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (isOpenCallback) {
            isOpenCallback(showModal);
        }
    }, [showModal, isOpenCallback]);

    return (
        <>
            <LuInfo
                className='text-border-default size-5'
                onClick={() => setShowModal(true)}
                id={ID}
            />
            {showModal && (
                <GeneralInfoModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                />
            )}
        </>
    );
};

export default GeneralInfoButton;
